import { Chip, Tooltip } from "@mui/material";
import {
  type GridColDef,
  type GridRenderCellParams,
} from "@mui/x-data-grid-pro";

// 「参謀くん連携」列は参謀くん SSO 連携済みユーザー かつ LaunchDarkly フラグが
// 有効な場合のみ表示する（useShowSendToSamboKun が両方を AND で判定）。
// 連携機能を使わないユーザーには列自体を見せない方が情報過多にならず分かりやすい。
// allMatters / ownerInfo など複数 feature の DataGrid から呼び出すため partner
// 配下に列定義を切り出して一元管理する。renderCell は row を参照しないので
// 行型のジェネリクスは持たせない（呼び出し側の責務を最小化）。
export const createSamboKunColumn = (): GridColDef => ({
  field: "isLinkableToPartner",
  headerName: "参謀くん連携",
  width: 160,
  sortable: false,
  align: "center",
  headerAlign: "center",
  // valueFormatter を空文字にしてセルのデフォルトテキスト描画を抑止する
  valueFormatter: () => "",
  renderCell: ({ value }: GridRenderCellParams<boolean>) => {
    if (value === false) {
      return (
        <Tooltip
          title="連携条件を満たしていないため、参謀くんへの連携対象外です"
          placement="top"
          arrow
        >
          <Chip label="連携対象外" size="small" variant="outlined" />
        </Tooltip>
      );
    }
    return null;
  },
});
